function initializeAboutSections(root = document) {
  root.querySelectorAll('[data-sp-founder-reveal]:not([data-sp-initialized])').forEach((section) => {
    section.dataset.spInitialized = 'true';
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.22, rootMargin: '0px 0px -8% 0px' });
    observer.observe(section);
  });

  root.querySelectorAll('[data-sp-about-timeline]:not([data-sp-initialized])').forEach((timeline) => {
    timeline.dataset.spInitialized = 'true';
    const tabs = [...timeline.querySelectorAll('[role="tab"]')];
    const selectTab = (tab) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected.toString());
        if (selected) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
        item.tabIndex = selected ? 0 : -1;
        const panel = timeline.querySelector(`#${item.getAttribute('aria-controls')}`);
        if (panel) panel.setAttribute('aria-hidden', (window.innerWidth >= 990 && !selected).toString());
      });
    };
    const syncPanels = () => tabs.forEach((item) => {
      const panel = timeline.querySelector(`#${item.getAttribute('aria-controls')}`);
      if (panel) panel.setAttribute('aria-hidden', (window.innerWidth >= 990 && item.getAttribute('aria-selected') !== 'true').toString());
    });
    window.addEventListener('resize', syncPanels);
    syncPanels();
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : index + (event.key === 'ArrowDown' ? 1 : -1);
        nextIndex = (nextIndex + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        selectTab(tabs[nextIndex]);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initializeAboutSections());
document.addEventListener('shopify:section:load', (event) => initializeAboutSections(event.target));
